import React, { ReactNode } from 'react';

interface PanelProps {
  title: string;
  extra?: ReactNode;
  children: ReactNode;
  className?: string;
}

export default function Panel({ title, extra, children, className = '' }: PanelProps) {
  return (
    <section className={`dashboard-panel ${className}`}>
      <div className="dashboard-panel__header">
        <h2>{title}</h2>
        {extra && <div className="dashboard-panel__extra">{extra}</div>}
      </div>
      {children}
    </section>
  );
}
